<template>
  <router-link
    tag="div"
    :to="{name: 'recipeView', params: { id: recipe.id }}"
    class="recipe"
  >
    <div class="thumb">
      <a>
        <img
          v-if="recipe.bannerUrl"
          :src="recipe.bannerUrl"
          class="card-img-top"
          onerror="this.onerror=null;this.src='/static/img/img-error.png';"
        />
        <div
          v-if="!recipe.bannerUrl"
          class="banner-fill d-flex align-items-center justify-content-center"
        >
          <span>
            <font-awesome-icon icon="book-reader" size="5x" />
          </span>
        </div>
      </a>
      <div class="produced" v-if="recipe.madeInProject">CultureLabs pilot project</div>
    </div>
    <div class="text">
      <router-link
        :title="recipe.title"
        class="title"
        :to="{ name: 'recipeView', params: { id: recipe.id }}"
      >
        {{ recipe.title | truncate(55, '...') }}
      </router-link>

      <p class="description">
        {{ recipe.description }}
      </p>

      <b-row class="px-3 d-flex justify-content-between">
        <b-col class="col-8 pl-0">
          <div class="creator" :title="recipe.creator.login">
            By <b>{{ recipe.creator.login }}</b>
          </div>
        </b-col>
        <b-col v-if="isEditable" class="col-1 text-center">
          <router-link
            class="text-dark mr-1"
            :to="{ name: 'recipeEdit', params: { id: recipe.id }}"
            title="Edit the recipe"
            v-b-tooltip.hover.top
          >
            <font-awesome-icon icon="edit" />
          </router-link>
        </b-col>
        <b-col v-if="isDeletable" class="col-1 text-center">
          <b-link
            class="text-dark mr-1"
            title="Delete the recipe"
            v-b-tooltip.hover.top
            @click.prevent="showMsgDelete(recipe.id, recipe.title)"
          >
            <font-awesome-icon icon="trash-alt" />
          </b-link>
        </b-col>
        <b-col v-if="isShareable" class="col-1 text-center">
          <b-link
            class="text-dark"
            to="#" @click.prevent="shareRecipe(recipe.id)"
            title="Share the recipe"
            v-b-tooltip.hover.top
          >
            <font-awesome-icon icon="share-alt" />
          </b-link>
        </b-col>
        <b-col v-if="canBeBookemarked" class="col-1 text-center">
          <b-link
            class="text-dark"
            :title="computedBookmark === false ? 'Add bookmark' : 'Remove Bookmark'"
            v-b-tooltip.hover.top
            v-on:click.stop="bookmarkRecipe(recipe)"
          >
            <i :class="computedBookmark ? 'fas fa-bookmark' : 'far fa-bookmark'" />
          </b-link>
        </b-col>
      </b-row>
    </div>
  </router-link>
</template>

<script>
import { eventBus } from '../../main';
import { mapGetters } from "vuex";

export default {
  name: 'recipeCard',
  props: {
    'recipe': Object
  },
  data() {
    return {
      bookmarked: undefined
    }
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    computedBookmark () {
      if (this.bookmarked !== undefined) {
        return this.bookmarked;
      }
      else if (this.recipe.bookmarked) {
        return this.recipe.bookmarked;
      }
      else {
        return false;
      }
    },
    isShared () {
      // check if the recipe is shared
      if (this.recipe.rights === 'READ' || this.recipe.rights === 'WRITE') {
        return this.recipe.isShared
      }
    },
    isEditable () {
      // check if share action is allowed
      return this.recipe.rights === 'OWN' || this.recipe.rights === 'WRITE'
    },
    isDeletable () {
      // check if share action is allowed
      return this.recipe.rights === 'OWN'
    },
    isShareable () {
      // check if share action is allowed
      return this.isEditable;
    },
    canBeBookemarked() {
      return this.authenticatedUser && ((this.recipe.publicReadable && this.recipe.rights !== 'OWN' ) || this.recipe.rights === 'READ' || this.recipe.rights === 'WRITE');
    },
    getTitle () {
      let title = this.recipe.title
      if (title) {
        return title
      }
      return '<Untitled>'
    }
  },
  methods: {
    showMsgDelete (recId, recTitle) {
      this.boxTwo = ''
      this.$bvModal.msgBoxConfirm('Please confirm that you want to delete this recipe.', {
        title: 'Are you sure you want to delete ' + recTitle + '?',
        size: 'bg',
        buttonSize: 'bg',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          this.boxTwo = value
          if (this.boxTwo) {
            this.deleteRecipe(recId)
          } else {
          }
        })
        .catch(error => {
          alert('An error occurred! Please refresh the page.' + error)
        })
    },
    deleteRecipe (recipeId) {
      this.$store.dispatch('deleteRecipeEntity', recipeId).then(
        data => {
          window.location.reload()
        })
    },
    shareRecipe (recipeId) {
      let b = [recipeId, this.recipe.title]
      console.log(b)
      eventBus.$emit('shareRecipe', b)
    },
    bookmarkRecipe(recipe) {
      if (!this.computedBookmark) {
        this.$store.dispatch("bookmarkRecipe", recipe.id)
          .then((response) => {
            if (response.status === 200) {
              this.bookmarked = true;
            }
          });
      }
      else {
        this.$store.dispatch("deleteBookmarkRecipe", recipe.id)
          .then((response) => {
            if (response.status === 200) {
              this.bookmarked = false;
            }
          });
      }
    }
  }
}
</script>

<style scoped>
  .banner-fill {
    max-height: 148px;
    min-height: 148px;
    background-color: #aeaeae;
    color: #F7F7F7;
    border-top-right-radius: 4px;
    border-top-left-radius: 4px;
  }

  .card-img-top {
    width: 100%;
    max-height: 148px;
    min-height: 148px;
    object-fit: cover;
  }

  .recipe {
    max-width: 333px;
    background: #fff;
    position: relative;
    border: 1px solid #F7F7F7;
    border-radius: 6px;
  }

  .text {
    width: 100%;
    padding: 25px;
    background-color: #F7F7F7;
    min-height: 244px;
  }

  .title {
    font-size: 18px;
    font-weight: bold;
    margin: 0 0 10px 0;
    display: block;
    color: #000000;
    overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis;
  }

  .description {
    height: 120px;
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 56px;
  }

  .creator {
    overflow:hidden;
    white-space:nowrap;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/recipes/RecipeCard.vue